export type HomeworkHelpType = 'FINISHING_HOMEWORK' | 'CHECKING_ANSWERS' | 'STUDYING_FOR_TEST' | 'PROOFREADING';

export const homeworkHelpTypeMap: Record<string, { text: string }> = {
  FINISHING_HOMEWORK: { text: 'Finishing homework' },
  CHECKING_ANSWERS: { text: 'Checking answers' },
  STUDYING_FOR_TEST: { text: 'Studying for a test' },
  PROOFREADING: { text: 'Proofreading' },
};

// Map for converting backend subject values to display text
export const homeworkHelpSubjectMap: Record<string, { text: string }> = {
  BASIC_MATH: { text: 'Basic math' },
  PRE_ALGEBRA: { text: 'Pre-algebra' },
  ELEMENTARY_SCIENCE: { text: 'Elementary science' },
  EARTH_SCIENCE: { text: 'Earth science' },
  SCIENCE: { text: 'Science' },
  ENGLISH: { text: 'English' },
  ESSAY_WRITING: { text: 'Essay writing' },
  SOCIAL_STUDIES: { text: 'Social studies' },
  ARABIC: { text: 'Arabic' },
  ARMENIAN: { text: 'Armenian' },
  BENGALI: { text: 'Bengali' },
  BULGARIAN: { text: 'Bulgarian' },
  BURMESE: { text: 'Burmese' },
  CHINESE: { text: 'Chinese' },
  CREOLE: { text: 'Creole' },
  CZECH: { text: 'Czech' },
  DANISH: { text: 'Danish' },
  DUTCH: { text: 'Dutch' },
  ESPERANTO: { text: 'Esperanto' },
  ESTONIAN: { text: 'Estonian' },
  FANTI: { text: 'Fanti' },
  FARSI: { text: 'Farsi' },
  FINNISH: { text: 'Finnish' },
  FRENCH: { text: 'French' },
  GERMAN: { text: 'German' },
  GREEK: { text: 'Greek' },
  HAUSA: { text: 'Hausa' },
  HAWAIIAN: { text: 'Hawaiian' },
  HEBREW: { text: 'Hebrew' },
  HINDI: { text: 'Hindi' },
  HUNGARIAN: { text: 'Hungarian' },
  IGBO: { text: 'Igbo' },
  IRISH: { text: 'Irish' },
  ITALIAN: { text: 'Italian' },
  JAPANESE: { text: 'Japanese' },
  KOREAN: { text: 'Korean' },
  MANDARIN: { text: 'Mandarin' },
  NORWEGIAN: { text: 'Norwegian' },
  OTHER: { text: 'Other' },
  POLISH: { text: 'Polish' },
  PORTUGUESE: { text: 'Portuguese' },
  PUNJABI: { text: 'Punjabi' },
  RUSSIAN: { text: 'Russian' },
  SIGN_LANGUAGE: { text: 'Sign language' },
  SINGALESE: { text: 'Singalese' },
  SPANISH: { text: 'Spanish' },
  SWAHILI: { text: 'Swahili' },
  SWEDISH: { text: 'Swedish' },
  TEMME: { text: 'Temme' },
  THAI: { text: 'Thai' },
  TURKISH: { text: 'Turkish' },
  TWI: { text: 'Twi' },
  UKRAINIAN: { text: 'Ukrainian' },
  URDU: { text: 'Urdu' },
  WELSH: { text: 'Welsh' },
  YIDDISH: { text: 'Yiddish' },
  CHINESE_CANTONESE: { text: 'Chinese (cantonese)' },
  CHINESE_MANDARIN: { text: 'Chinese (mandarin)' },
  CHINESE_OTHER_DIALECTS: { text: 'Chinese (other dialects)' },
  HAITIAN_CREOLE: { text: 'Haitian creole' },
  FANTE: { text: 'Fante' },
  AMERICAN_SIGN_LANGUAGE: { text: 'American sign language' },
  SINHALA: { text: 'Sinhala' },
  TEME: { text: 'Teme' },
  TIGRE: { text: 'Tigre' },
  TIGRINYA: { text: 'Tigrinya' },
};

export const hasHomeworkHelp = (profileData: Record<string, any>): boolean => {
  return !!(
    profileData.homeworkHelp &&
    ((profileData.homeworkHelpType && profileData.homeworkHelpType.length > 0) ||
      (profileData.homeworkHelpSubjects && profileData.homeworkHelpSubjects.length > 0))
  );
};

export const getHomeworkHelpData = (
  profileData: Record<string, any>
): {
  homeworkHelpType: HomeworkHelpType[];
  homeworkHelpSubjects: string[];
} => {
  return {
    homeworkHelpType: profileData.homeworkHelpType || [],
    homeworkHelpSubjects: profileData.homeworkHelpSubjects || [],
  };
};
